import { Button } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  min-height: 500px;

  @media (max-width: 1380px) {
    min-height: 522px;
  }
`;

export const Content = styled.div`
  display: flex;
  padding: 8px;
  padding-bottom: 14px;
  font-size: 0.75rem;
  border: 1px solid #f0f0f0;
  border-radius: 8px;

  & + & {
    margin-top: 8px;
  }

  > div {
    flex: 1;
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .receivable-account-area {
    display: flex;

    span {
      margin-left: 16px;
    }
  }

  .receivable-account {
    font-size: 0.875rem;
    text-decoration: none;
    color: var(--main-color);
    margin-right: 10px;
    line-height: 16px;
  }
`;

export const BodyCard = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 12px;

  span + span {
    margin-top: 12px;
  }
`;

export const BodyCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const DownloadArea = styled.div`
  display: flex;
  flex: 2;
  max-width: 150px;
  align-items: center;
  justify-content: flex-end;
`;

export const BottonCustom = styled(Button)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
  }
`;
